module.exports = __webpack_public_path__ + "ptc_nakagawa_J2.f95900c8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/stories/nakagawa/parent_to_child/ptc_nakagawa_J2.jpg
// module id = BPYU
// module chunks = 0